<template>
  <v-btn :variant="getVariant" :width="getWidth" color="primary" rounded="xl" class="text-none" @click.stop="$emit('action')">
    <span :class="getColorClass">
      <slot name="prepend"/>
    </span>
    <span :class="getColorClass">
      <slot name="default"/>
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseLinkButton',
  props: ["background", "delete", "width"],
  computed: {
    getVariant() {
      return this.background ? 'flat' : 'text';
    },
    getColorClass() {
      if(this.background) {
        return 'sm-white';
      }
      else if(this.delete) {
        return 'sm-error';
      }
      else {
        return 'sm-link';
      }
    },
    getWidth() {
      return this.width ? this.width : 'auto';
    }
  },
}
</script>